module.exports = __webpack_public_path__ + "static/media/bg-image-2.6246a47e.jpg";